import { AuditableEntity } from "./audible-entity.model";
import { ContractBaseDeliveryAddress } from "./contract-base-delivery-address";
import { ContractFile } from "./contract-file.model";
import { Customer } from "./customer.model";
import { ElectricityContract } from "./electricity-contract.model";
import { FacilityType } from "./facility-type.model";
import { GasContract } from "./gas-contract.model";
import { Supplier } from "./supplier.model";

export class ContractBase extends AuditableEntity {
    constructor(_Id?: number, _CustomerId?: number, _DeliveryAddressId?: number, _FacilityTypeId?: number, _SupplierId?: number,
        _ContractDate?: Date, _ContractStartDate?: Date, _ContractEndDate?: Date, _IsActive?: boolean,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id;
        this.CustomerId = _CustomerId;
        this.DeliveryAddressId = _DeliveryAddressId;
        this.FacilityTypeId = _FacilityTypeId;
        this.SupplierId = _SupplierId;
        this.ContractDate = _ContractDate || new Date();
        this.ContractStartDate = _ContractStartDate || new Date();
        this.ContractEndDate = _ContractEndDate || new Date();
        this.IsActive = _IsActive || true;

        this.Customer = new Customer();
        this.FacilityType = new FacilityType();
        this.Supplier = new Supplier();

        this.ContractBaseDeliveryAddresses = new Array<ContractBaseDeliveryAddress>();
        this.ContractFiles = new Array<ContractFile>();
        this.ElectricityContracts = new Array<ElectricityContract>();
        this.GasContracts = new Array<GasContract>();
    }

    public Id: number;
    public CustomerId: number;
    public DeliveryAddressId: number;
    public FacilityTypeId: number;
    public SupplierId: number;
    public ContractDate: Date;
    public ContractStartDate: Date;
    public ContractEndDate: Date;
    public IsActive: boolean;

    public Customer: Customer;
    public FacilityType: FacilityType;
    public Supplier: Supplier;

    public ContractBaseDeliveryAddresses: ContractBaseDeliveryAddress[];
    public ContractFiles: ContractFile[];
    public ElectricityContracts: ElectricityContract[];
    public GasContracts: GasContract[];
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/contract-base.model.ts